import { useState } from 'react';
import {
  Collapse, Dropdown, DropdownItem, DropdownMenu, DropdownToggle, Navbar, NavbarBrand,
  NavbarToggler, NavItem, NavLink,
} from 'reactstrap';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../auth/useAuth.js';
import { ThemeToggle } from './ThemeToggle.jsx';
import './NavMenu.css';

export function NavMenu() {
  const { user, isAdmin, logout } = useAuth();
  const navigate = useNavigate();
  const [collapsed, setCollapsed] = useState(true);
  const [adminOpen, setAdminOpen] = useState(false);

  function handleLogout() {
    logout();
    navigate('/login', { replace: true });
  }

  return (
    <header>
      <Navbar className="navbar-expand-md navbar-toggleable-md border-bottom box-shadow mb-3 bg-body-tertiary" container>
        <NavbarBrand tag={Link} to="/">PickemsApp</NavbarBrand>
        <NavbarToggler onClick={() => setCollapsed(!collapsed)} className="mr-2" />

        <Collapse className="d-md-inline-flex flex-md-row-reverse" isOpen={!collapsed} navbar>
          {user ? (
            <ul className="navbar-nav flex-grow align-items-md-center">
              <NavItem><NavLink tag={Link} to="/picks">Picks</NavLink></NavItem>
              <NavItem><NavLink tag={Link} to="/leaderboard/weekly">Weekly</NavLink></NavItem>
              <NavItem><NavLink tag={Link} to="/leaderboard/season">Season</NavLink></NavItem>
              <NavItem><NavLink tag={Link} to="/schedule">Schedule</NavLink></NavItem>

              {isAdmin && (
                <Dropdown nav inNavbar isOpen={adminOpen} toggle={() => setAdminOpen(!adminOpen)}>
                  <DropdownToggle nav caret>Admin</DropdownToggle>
                  <DropdownMenu end>
                    <DropdownItem tag={Link} to="/admin/users">Users</DropdownItem>
                    <DropdownItem tag={Link} to="/admin/picks">Edit picks</DropdownItem>
                    <DropdownItem tag={Link} to="/admin/invites">Invite codes</DropdownItem>
                    <DropdownItem divider />
                    <DropdownItem tag={Link} to="/admin/sync">ESPN sync</DropdownItem>
                  </DropdownMenu>
                </Dropdown>
              )}

              <NavItem className="ms-md-3 d-flex align-items-center gap-2">
                <span className="navbar-text small">{user.displayName}</span>
                <ThemeToggle />
                <button type="button" className="btn btn-sm btn-outline-secondary" onClick={handleLogout}>
                  Sign out
                </button>
              </NavItem>
            </ul>
          ) : (
            <ul className="navbar-nav flex-grow align-items-md-center">
              <NavItem><NavLink tag={Link} to="/login">Sign in</NavLink></NavItem>
              <NavItem><NavLink tag={Link} to="/register">Register</NavLink></NavItem>
              <NavItem className="ms-md-3 d-flex align-items-center">
                <ThemeToggle />
              </NavItem>
            </ul>
          )}
        </Collapse>
      </Navbar>
    </header>
  );
}
